export const zoneToCountryMapping = {
  UK: ['GB', 'JE', 'GG'],
  EU: [
    'HU',
    'DE',
    'DK',
    'FR',
    'NL',
    'SE',
    'FI',
    'SK',
    'CH',
    'BE',
    'IT',
    'ES',
    'IE',
    'LU',
    'CZ',
    'PL',
    'AT',
    'PT',
    'IS',
  ],
};

export class CountryHelpers {}
